import ACCOUNT_ACTION_TYPES from '../submodules/shared/actions/action-types';
import { getAccountAccess, getAccountDetails } from '../utils/api';
import { notifyTimeout } from '../utils/notify-timeout';

import ACTION_TYPES from './action-types';

const NOT_AUTHORIZED_MESSAGE = {
    type: 'danger',
    message: 'You are not authorized.',
};

let bootstrapInFlight = null;

const isMissingAccountId = (accountId) => (accountId ?? '') === '';

export const notificationMessage = (payload) => (dispatch) =>
    dispatch({
        type: ACTION_TYPES.SHOW_NOTIFICATION_MESSAGE,
        payload,
    });

export const clearNotifications = () => (dispatch) =>
    dispatch({
        type: ACTION_TYPES.CLEAR_NOTIFICATION_MESSAGES,
    });

export const hideNotificationItem = (payload) => (dispatch) =>
    dispatch({
        type: ACTION_TYPES.HIDE_NOTIFICATION_MESSAGE,
        payload,
    });

export const fetchAppAccess = (payload) => (dispatch) => {
    return getAccountAccess(payload).then(
        ({ data }) => {
            if (!data) {
                dispatch({
                    type: ACTION_TYPES.SHOW_NOTIFICATION_MESSAGE,
                    payload: NOT_AUTHORIZED_MESSAGE,
                });
            }
            dispatch({
                type: ACTION_TYPES.SET_APP_ACCESS,
                payload: data,
            });
        },
        (err) => {
            notifyTimeout(dispatch, err);
        },
    );
};

export const bootstrapAppAccess = () => (dispatch) => {
    if (bootstrapInFlight) {
        return bootstrapInFlight;
    }

    bootstrapInFlight = (async () => {
        try {
            const { data } = await getAccountDetails();

            dispatch({
                type: ACCOUNT_ACTION_TYPES.SET_ACCOUNT_DETAILS,
                payload: data,
            });

            const accountId = data?.sansAccountID;

            if (isMissingAccountId(accountId)) {
                dispatch(notificationMessage(NOT_AUTHORIZED_MESSAGE));
                return;
            }

            await dispatch(fetchAppAccess({ accountId }));
        } catch (err) {
            if (notifyTimeout(dispatch, err)) {
                return;
            }
            dispatch(notificationMessage(NOT_AUTHORIZED_MESSAGE));
        } finally {
            bootstrapInFlight = null;
        }
    })();

    return bootstrapInFlight;
};
